import { FC } from "react";
import { useTranslation } from "react-i18next";

import { ArrowRight } from "@/assets/icons/ds";
import { ProductCard } from "@/components/Layout/BaseLayouts/ProductCard/ProductCard";
import { ProductCardFooterItem } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";

export const GoToTariffOverviewTile: FC = () => {
  const { t } = useTranslation(["partnerPortal"], {
    keyPrefix: "cockpit",
  });
  const { t: tDefault } = useTranslation();

  return (
    <ProductCard
      dataTestid="tariff-overview-tile"
      header={
        <div className="flex h-full w-full flex-col items-start gap-3 pt-4">
          <p className="text-body-sm text-foreground-secondary">
            {t("mobileInternet")}
          </p>
          <h2 className="w-full text-headline-md font-semibold leading-sm text-foreground-primary">
            {t("description")}
          </h2>
        </div>
      }
      footer={
        <ProductCardFooterItem
          variant="button"
          label={t("callToAction")}
          icon={<ArrowRight />}
          href={tDefault("Common.links.rates")}
        />
      }
    />
  );
};
